import React from 'react';
import ParameterChangeAction from "../actions/ParameterChangeAction";
import SongStore from '../stores/SongStore';
import PropTypes from 'prop-types';
import MidiMapSelect from '../actions/MidiMapSelect';

var halfPi = Math.PI / 2;
var quarterPi = halfPi / 2;
var twoPi = Math.PI * 2;
var startAngle = -Math.PI - quarterPi;
var stopAngle = quarterPi;

class StandardKnob extends React.Component {

	static contextTypes = {
		executeAction: PropTypes.func.isRequired,
		getStore: PropTypes.func.isRequired
	};

	constructor(props, context) {
		super(props, context);
		this.displayName = 'StandardKnob';

		this.state = {
			value: this.props.param.value,
			normalized: this.props.param.normalized,
			mouseControl: false
		};

		this.startMouse = {};

		this._mouseMove = this.onMouseMove.bind(this);
		this._mouseUp = this.onMouseUp.bind(this);

		this.listener = this.handleNewValue.bind(this);

		this._bindToUpdate(this.props.param.path);

		this.context.getStore(SongStore).on("MIDI_MAP_MODE_CHANGE", (isEnabled) => {
			this.setState({
				mapMode: isEnabled
			});
		})

	}

	componentWillUnmount() {
		this._unbindToUpdate(this.props.param.path);
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.name != this.props.param.name) {
			this._unbindToUpdate(this.props.param.path);
			this._bindToUpdate(nextProps.param.path);
		}
		this.handleNewValue({
			value: nextProps.param.value,
			normalized: nextProps.param.normalized
		});
	}

	componentDidUpdate(props, state) {
		if(this.state.mouseControl && !state.mouseControl) {
			document.addEventListener('mousemove', this._mouseMove);
			document.addEventListener('mouseup', this._mouseUp);
		} else if(!this.state.mouseControl && state.mouseControl) {
			document.removeEventListener('mousemove', this._mouseMove);
			document.removeEventListener('mouseup', this._mouseUp);
		}
	}

	onMouseMove(event) {
		var rads = Math.atan2(event.pageY - this.startMouse.y, event.pageX- this.startMouse.x);

		if(rads > halfPi) {
			rads = rads - twoPi;
		}

		rads = Math.max(Math.min(stopAngle, rads), startAngle);

		rads = (rads - startAngle) / (stopAngle - startAngle);

		this.context.executeAction(ParameterChangeAction, {
			normalized: rads*127,
			path: this.props.param.path
		});

	}

	onMouseUp(event) {
		event.preventDefault();
		this.setState({
			mouseControl: false
		});
	}

	_bindToUpdate(name) {
		this.context.getStore(SongStore).on(name + "_UPDATE", this.listener);
	}

	_unbindToUpdate(name) {
		this.context.getStore(SongStore).removeListener(name + "_UPDATE", this.listener);
	}

	handleNewValue(payload) {
		this.setState({
			value: payload.value,
			normalized: payload.normalized
		});
	}

	handleClick(event) {
		if(this.state.mapMode) {
			event.preventDefault();
			this.context.executeAction(MidiMapSelect, {
				path: this.props.param.path
			});
		}
	}

	handleKnobDown(event) {
		if(this.state.mapMode) return;
		event.preventDefault();

		this.startMouse = {
			x: event.pageX,
			y: event.pageY
		};

		this.setState({
			mouseControl: true
		});
	}

	render() {

		var style = {
			transform: "rotate(" + ((this.state.normalized/127) * 270 - 135) + "deg)"
		};
		return (
			<div className={ (this.state.mapMode ? "map-mode " : "" ) + "knob" } onClick={this.handleClick.bind(this)}>
				<p>{this.props.param.name}</p>
				<div className="dial" onMouseDown={this.handleKnobDown.bind(this)}>
					<div className="chip" style={style}></div>
				</div>
				<input
					type="number"
					value={this.state.value}
					min={this.props.param.min}
					max={this.props.param.max}
					step={this.props.param.step}
					onChange={this.handleInputChange.bind(this)}/>
			</div>
		);
	}

	handleInputChange(event) {
		this.context.executeAction(ParameterChangeAction, {
			value: event.target.value,
			path: this.props.param.path
		});
	}
}

export default StandardKnob;
